import { createContext, useContext, useEffect, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FeatureFlagsContext = createContext({
  flags: {},
  loading: true,
  isEnabled: () => true,
  refresh: () => {},
});

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/api/feature-flags`);
      if (r.ok) {
        const d = await r.json();
        setFlags(d.flags || {});
      }
    } catch (e) {
      console.error('Failed to load feature flags:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Default-on if unknown — newly added flags should appear immediately
  const isEnabled = useCallback(
    (key) => (key in flags ? flags[key] !== false : true),
    [flags]
  );

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, isEnabled, refresh }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
